import axios from 'axios';
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBTypography } from 'mdb-react-ui-kit';

import { useParams, useNavigate } from 'react-router-dom';
import React, { useEffect,  useContext, useCallback, useRef } from 'react';
import { MiscContext } from '../context/MiscProvider';

function PrivacyPolicy() {
  const navigate = useNavigate();
  const { pp, setPp,privacyData, setPrivacyData } = useContext(MiscContext);
  const { main } = useParams();

  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const didFetchRef = useRef(false);

  const fetchItems = useCallback(async () => {
    if (didFetchRef.current || pp) return;
    didFetchRef.current = true;
    try {
      const response = await axios.get(`${baseUrl}/privacypolicy`);
      setPrivacyData(response.data);
    } catch (error) {
      console.error("Error fetching privacy policy data:", error);
    }
  }, [baseUrl, pp, setPrivacyData]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  if (!privacyData) {
    return null; // Or a loading spinner
  }

  return (
    <>
      {main ? (
        createPrivacy(privacyData)
      ) : (
        <MDBModal open={pp} className='text-center' staticBackdrop={true} onClose={() => { setPp(false); navigate('/home'); }}>
          <MDBModalDialog centered={true} size="lg">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBBtn className='btn-close' color='none' onClick={() => setPp(false)}></MDBBtn>
              </MDBModalHeader>
              {createPrivacy(privacyData)}
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      )}
    </>
  );
}

function createPrivacy(privacyData) {
  return (
    <MDBModalBody>
      {privacyData?.map((section, index) => (
        <div key={index} className="d-flex flex-column align-items-center">
          <strong className='text-primary'>Update Date</strong>
          <p>Last Update: {section.effectiveDate.modifiedDate}</p>

          <strong style={{ color: 'green' }} className='text-capitalize lead mb-0 fs-3 fw-bold'>Introduction</strong>
          <p style={{ minWidth: '10rem', textAlign: 'left', display: 'flex' }} className='ms-5 me-5'>{section.introduction}</p>

          {Object.entries(section).map(([key, value], index) => {
            if (typeof value === 'object' && key !== 'effectiveDate' && key !== 'introduction') {
              return (
                <MDBCard key={index} className='ms-2 me-2 mb-2'>
                  <MDBCardHeader>
                    <figure className='text-center mb-0 '>
                      <MDBTypography blockquote>
                        <p className='text-capitalize  text-success'>{key}</p>
                      </MDBTypography>
                      <figcaption className='mb-0 blockquote-footer'>
                        <cite title='Source Title'>{value.description}</cite>
                      </figcaption>
                    </figure>
                  </MDBCardHeader>
                  <MDBCardBody className='align-items-left'>
                    <MDBTypography listUnStyled className='mb-0 align-items-left' style={{ minWidth: '10rem', textAlign: 'left' }}>
                      {value.details.map((item, index) => (
                        <li className='mb-1' key={index} style={{ minWidth: '10rem', textAlign: 'left', display: 'flex' }}>
                          <MDBIcon icon='check-circle' className='me-2 text-info' />{item}
                        </li>
                      ))}
                    </MDBTypography>
                  </MDBCardBody>
                </MDBCard>
              );
            }
            return null;
          })}
        </div>
      ))}
    </MDBModalBody>
  );
}

export default PrivacyPolicy;
